export const FLAG_FORM_ID = 'flag-form';
export const MONEY_SEPARATOR = ',';
